import React from "react";
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useActionData, useParams, useLocation, useSearchParams  } from 'react-router-dom';
import "./Produtos.css";
//import BannerCarousel from '../../Componentes/BannerCarousel';
import ItensProdutos from "../../Componentes/Cabecalho/ItensProdutos";
import CaminhoRato from "../../Componentes/Cabecalho/CaminhoRato";
import DetalhesProduto from "./Detalhes"
import $ from "jquery";
import { Heart, HeartFill } from 'react-bootstrap-icons';
// import { CCarousel, CCarouselCaption, CCarouselItem, CImage } from '@coreui/react'
import { LocalData } from "../../Componentes/Util/LocalData"
//import Menu from "../../Componentes/Cabecalho/Menu.js"
//import HorarioAtendimento from "../../Componentes/HorarioAtendimento.js";
import MudaPagina from "../../Componentes/Util/Navegacao.js"
import useQuery from "../../Componentes/Util/useQuery.js";
import InicioProdutos from "./Inicio.js";
//import BuscaAPI from "../../Componentes/Util/BuscaAPI"
import HTML from 'html-react-parser';

export default function Produtos() {
  let { idCategoria, idProduto } = useParams();
  //console.log("idCategoria", idCategoria);
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  let query = useQuery();
  let buscarProduto = query.get("sr");
  //console.log("BUSCAR", buscarA);

  const [produtos, setProdutos] = useState([]);
  const [Prod, setProd] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0)
  const [localdataPROD, setLocaldataPROD] = useState("");
  const [cabecalho, setCabecalho] = useState();

  useEffect(() => {
    const fetchProdutos = async () => {
      $("#objCarregaTela").addClass("display-block");  
      try{
      //LocalData.set("prodID",[]);
      if(LocalData.get("prodID") !== "")
        setLocaldataPROD(JSON.parse(LocalData.get("prodID")));
      }catch(e){}

      //try {
        //const response = await axios.get('http://localhost:21165/api/produtos');
        
        //const response = await axios.get('http://178.156.175.191:3001/api/produtos');
        const response = await axios.get("https://api.construmarcas.com.br/api/produtos");
        // console.log("teste", response.data);
        setProdutos(response.data);
      //} catch (error) {
        //console.error('Error fetching products:', error);
      //}

    //caso tenha um cabecalho cadastrado, conforme identificado pelo nome do produto (!!-!!), criar variavel abaixo
    
      let cabec = null;
      try{
        cabec = JSON.parse(response.data.find((produto) => {
          //console.log((JSON.parse(produto.dados).nome.search("!!-!!")));
          let cabecalho =  JSON.parse(produto.dados).nome.indexOf("!!-!!") > -1;
          return JSON.parse(produto.dados).idCategoria === idCategoria && cabecalho;
        }).dados);
      }catch(error){}
      //console.log("cabec",cabec);
      setCabecalho(cabec);
      $("#objCarregaTela").removeClass("display-block");
    };

    fetchProdutos();
  }, [idCategoria, LocalData.get("prodID")]);

  useEffect(() => {
      try{
        //verifica se está abrindo algum produto
        //se sim, ele criar um loop para aguardar o produto ser criado na vitrine
        if (searchParams.get('idprod')) {
          let existeProd = false;
          let intervalo = setInterval(() => {
            existeProd = $("#"+searchParams.get('idprod')).length > 0;
            console.log(existeProd);
            if(existeProd == true){
              clearInterval(intervalo);
              console.log("idddd: ", searchParams.get('idprod'));
              $("#"+searchParams.get('idprod')).trigger("click");
            }
          }, 100);
        }
        // if (searchParams.get('idprod')) {
        //   if($("#"+searchParams.get('idprod')))
        //     alert("FIM");
        //   //$("#"+searchParams.get('idprod')).trigger("click");
        //   //abreProd(searchParams.get('idprod'));
        // }
      }catch(e){}
  }, []);

  var categoriaDescricao = null;
  try{
    categoriaDescricao = produtos.find((produto) => {
      try {
        //console.log(JSON.parse(produto.dados));
        return JSON.parse(produto.dados).idCategoria === idCategoria;
      } catch (error) {
        return false;
      }
    });
    //console.log(categoriaDescricao);
  }catch(error){}


    const evCliqueProduto = (e) =>
    {
      $(".area-produto").addClass("produto-selecionado");
      $(".area-impressao-produto").removeClass("selecionado");

      let p = produtos.find((produto) => {
        try {
          return JSON.parse(parseInt(JSON.parse(produto.dados).id) === parseInt($(e.currentTarget).attr("id")));
        } catch (error) {
          return null;
        }
      });
      //console.log(p.dados);
      let __prod = {...p, ...{indexBanner: 0}};
      //console.log("__prod", __prod);
      setProd([__prod]);
      setActiveIndex(0);
      
      $("body").addClass("overflow-hidden");

      // Define o novo valor para o parâmetro 'filtro'
      searchParams.set('idprod', $(e.currentTarget).attr("id"));
      // Atualiza a URL sem recarregar a página
      setSearchParams(searchParams); 
    }

    const evCliqueEnviarParaLista = (e) => {
      e.preventDefault();
      e.stopPropagation();
      //alert(JSON.parse(LocalData.get("prodID")));

      let index = -1;
      let arrNovo, arr = [];

      try{
        if(LocalData.get("prodID") !== ""){
          index = JSON.parse(LocalData.get("prodID")).findIndex(val => val == parseInt($(e.currentTarget).parents(".capa").attr("id")));
          arr = JSON.parse(LocalData.get("prodID"));            
        }
      }catch(error){}

      arrNovo = parseInt($(e.currentTarget).parents(".capa").attr("id"));
      //alert(arrNovo);

      if($(e.currentTarget).hasClass("marcado")) {
        arr = arr.filter(num => num !== parseInt($(e.currentTarget).parents(".capa").attr("id")));
        $(`.vitrine .lista-produtos-categoria [id=${parseInt($(e.currentTarget).parents(".capa").attr("id"))}]`).find(".eu-quero-produto").removeClass("marcado");
      } else if(index == -1 && !$(e.currentTarget).hasClass("marcado")) {
        arr.push(arrNovo);
        $(`.vitrine .lista-produtos-categoria [id=${parseInt($(e.currentTarget).parents(".capa").attr("id"))}]`).find(".eu-quero-produto").addClass("marcado");
      }
        
      setLocaldataPROD(arr);        
      LocalData.set("prodID", JSON.stringify(arr));
      //console.log("LOCALDATA - PRODUTOS", JSON.parse(LocalData.get("prodID")));
      //LocalData.set("prodID","");
      AtualizaContador(arr);
    }
    
    function AtualizaContador(lista){
      //alert("AtualizaContador - PRODUTOS");
      if(lista.length > 0) {
        $(".lista-de-desejos").addClass("marcador");
      } else {
        $(".lista-de-desejos").removeClass("marcador");    
      }      
      $(".lista-de-desejos .contador").html(lista.length);
    }

    const evMarcarTodosProdutosCategoria = (e) => {
      e.preventDefault();
      e.stopPropagation();      

      $(".lista-produtos-categoria .capa:not(.display-none) .eu-quero-produto.marcado").trigger("click");
      $(".lista-produtos-categoria .capa:not(.display-none) .eu-quero-produto:not(.marcado)").trigger("click");
    }
    const evDesmarcarTodosProdutosCategoria = (e) => {
      e.preventDefault();
      e.stopPropagation();      

      $(".lista-produtos-categoria .eu-quero-produto.marcado").trigger("click");
    }
    //ao carregar a página, atualiza o contador de items da lista de desejos
    //AtualizaContador(localdataPROD);

    let ordemAlfaPRODs = produtos.sort(function (a, b) {
      if (JSON.parse(a.dados).nome > JSON.parse(b.dados).nome) {
        return 1;
      }
      if (JSON.parse(a.dados).nome < JSON.parse(b.dados).nome) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
    // console.log("###: ", ordemAlfaPRODs);
    
    let produtosFiltrados = ordemAlfaPRODs.filter(item => ((item.idCategoria === idCategoria || ((!idCategoria && buscarProduto && JSON.parse(item.dados).nome.toUpperCase().indexOf(buscarProduto.toUpperCase()) > -1))) && JSON.parse(item.dados).nome.indexOf("!!-!!") === -1));
    //console.log(produtosFiltrados);
    //console.log("teste",ordemAlfaPRODs, idCategoria);
    
    /***********************************************************/

    let FiltroMarcas = produtosFiltrados.filter(item => JSON.parse(item.dados).marca).map(item => JSON.parse(item.dados).marca);
    var arrFiltroMarcas = [];
    FiltroMarcas.forEach((el, i) =>{
        if($.inArray(el, arrFiltroMarcas) === -1)  
          arrFiltroMarcas.push(el);        
    });

    const evFiltrarPorMarca = (e) => {
      e.preventDefault();
      //e.stopPropagation();      

      let marca = e.currentTarget.value;
      if(marca !== "-"){
        //$(".lista-produtos-categoria .capa").show();
        $(".lista-produtos-categoria .capa").addClass("display-none");
        $(".lista-produtos-categoria").find(`div.capa[marca="${marca}"]`).removeClass("display-none");
      }else{
        $(".lista-produtos-categoria .capa").removeClass("display-none");
      }
      
      //let arr = produtosFiltrados.filter(item => JSON.parse(item.dados).marca === e.currentTarget.value);
      //console.log("arr",arr);
      //setProdutos(arr);
    }

    return (
        <>
          {/* <Menu></Menu> */}
          {/* <BannerCarousel banners={[
              {urlArea:"/imagens/Banner_transparent.png", url:"/imagens/bg_banner.jpg", descricao:"Imagens 001", caption:{titulo:"Título do banner", descricao:"Descrição do banner"}, indicators:false}
          ]} /> */}
          <div className="vitrine conteudo">
            <ItensProdutos classCSS={"desktop"} idCategoria={idCategoria}></ItensProdutos>
            <div className="produtos">
              <h3>
                <CaminhoRato caminho={categoriaDescricao ? JSON.parse(categoriaDescricao.dados).arvoreCategoria[JSON.parse(categoriaDescricao.dados).arvoreCategoria.length-1].descricaoCompleta : (buscarProduto || "") ? `Você está procurando por '${buscarProduto}'` : ''} divisor={">"}></CaminhoRato>
              </h3>
              
              {/* {console.log(cabecalho)} */}
              {
                (idCategoria || buscarProduto) &&
                <div className="area-filtros">
                  <button className="btn-marcar-todos" onClick={evMarcarTodosProdutosCategoria}>Marcar todos</button>
                  <button className="btn-desmarcar-todos" onClick={evDesmarcarTodosProdutosCategoria}>Desmarcar todos</button>
                  <select className="sl-filtrar-marcas" onChange={evFiltrarPorMarca}>
                    <option key={0} value="-">Todas as marcas</option> 
                    <option key={1} value=""></option>
                    {
                        arrFiltroMarcas.map(function(element, index){
                            // console.log("element", element);
                            return(
                                <option key={index+2} value={element}> {element}</option> 
                            )
                        })
                    }
                  </select>  
                </div>              
              }
              {
                (cabecalho) 
                    ? <div className="cabecalho">
                        <img alt={cabecalho.nome.split("!!-!!")[1]} src={cabecalho.anexos[0].url} />
                        <div>
                          {/* verifica se no início do nome do produto tem a referência !!-!!. Se sim, entende que este é apenas um cabeçalho */}
                          <h4 className="titulo">{ cabecalho.nome.split("!!-!!")[1] }</h4>
                          <div className="descricao">{ HTML(cabecalho.descricaoComplementar) }</div>
                        </div>
                      </div>
                    : <></> 
              }
              <div className="lista-produtos-categoria">
                {/* {console.log("produtos",produtos)} */}
                {
                  // (produtos) ?
                  // produtos.map((produto, index) => 
                  // {
                  (produtosFiltrados) ?
                  produtosFiltrados.map((produto, index) => 
                  {
                    let dados = JSON.parse(produto.dados);
                    //console.log("dados", dados);
                    // //console.log("dados", dados);
                    //try{
                      
                      //if((JSON.parse(produto.dados).idCategoria === idCategoria || ((!idCategoria && buscarProduto && dados.nome.search(buscarProduto.toUpperCase()) > -1) && buscarProduto || "")) && JSON.parse(produto.dados).nome.indexOf("!!-!!") === -1) {
                        let marcaPROD = "";
                        // console.log("dados", dados);
                        try{
                          if(localdataPROD.filter((a) => a == parseInt(JSON.parse(produto.dados).id)).length > 0)
                            marcaPROD = "marcado";
                        }catch(error){}
                        return (
                          <div key={produto.id} className="capa" id={JSON.parse(produto.dados).id} marca={dados.marca} onClick={evCliqueProduto}>
                            {
                              <div className="imagem" title={dados.nome} style={{"background":`url(${(dados.anexos.length > 0)&& dados.anexos[0].url})`}}></div>
                            }
                            <h3>{produto.nome}</h3>
                            <p>{dados.nome}</p>
                            <div className={`eu-quero-produto ${marcaPROD}`} onClick={evCliqueEnviarParaLista}>
                              {
                                <HeartFill size={24}></HeartFill>
                                // (marcaPROD) 
                                // ? <HeartFill size={24}></HeartFill>
                                // : <Heart size={24}></Heart>
                              }
                            </div>
                          </div>
                        )
                      //}
                    //}catch(error){
                      //console.log("Ocorreu um erro ao tentar exibir os produtos desta categorias.");
                    //}
                    // //try{
                    //   if((JSON.parse(produto.dados).idCategoria === idCategoria || ((!idCategoria && buscarProduto && dados.nome.search(buscarProduto.toUpperCase()) > -1) && buscarProduto || "")) && JSON.parse(produto.dados).nome.indexOf("!!-!!") === -1) {
                    //     let marcaPROD = "";
                    //     //  console.log("dados", dados);
                    //     try{
                    //       if(localdataPROD.filter((a) => a == parseInt(JSON.parse(produto.dados).id)).length > 0)
                    //         marcaPROD = "marcado";
                    //     }catch(error){}
                    //     return (
                    //       <div key={produto.id} className="capa" id={JSON.parse(produto.dados).id} onClick={evCliqueProduto}>
                    //         {
                    //           <div className="imagem" title={dados.nome} style={{"background":`url(${(dados.anexos.length > 0)&& dados.anexos[0].url})`}}></div>
                    //         }
                    //         <h3>{produto.nome}</h3>
                    //         <p>{dados.nome}</p>
                    //         <div className={`eu-quero-produto ${marcaPROD}`} onClick={evCliqueEnviarParaLista}><Heart size={24}></Heart></div>
                    //       </div>
                    //     )
                    //   }
                    // //}catch(error){
                    //   //console.log("Ocorreu um erro ao tentar exibir os produtos desta categorias.");
                    // //}
                  }) : <></>
                }
              </div>
              <DetalhesProduto Lista={Prod} AtualizaContador={AtualizaContador} evCliqueEnviarParaLista={evCliqueEnviarParaLista} ldPROD={localdataPROD} ></DetalhesProduto>
              {
                (!idCategoria && !buscarProduto) 
                  ? <InicioProdutos /> 
                  : (!idCategoria && (buscarProduto || "")) 
                    ? <></> 
                    : <></>
              }
            </div>
          </div>
        </>
    );
}